export function price(value: number) {
	return new Intl.NumberFormat('es-AR', {
		style: 'currency',
		currency: 'ARS',
		minimumFractionDigits: 2,
	}).format(value);
}

export function priceArg(value: number) {
	return new Intl.NumberFormat('en-AR', {
		style: 'currency',
		currency: 'ARG',
		minimumFractionDigits: 2,
	}).format(value);
}

export function formatNumber(value: number | string, decimals: number = 4): string {
	const numValue = typeof value === 'string' ? parseFloat(value) : value;
	return numValue.toLocaleString('es-AR', {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	});
}
